// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1ZmHw","title":"FrontImage_title__G84iJ"};